<template>
    <div>
        <p class="feedback--question" v-text="handlingForCountry"/>
        <textarea class="input__textarea feedback--textarea" v-model="feedback"/>
        <p class="error pause-error--message" v-if="errorHandler.response.length && !feedback" v-text="errorHandler.response"></p>
        <button @click.prevent="pauseSubscription" class="btn btn--primary btn--full-width confirm--button " v-text="$t('PAUSE_DELIVERIES_CONFIRM')"></button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

let subscriptionService = new SubscriptionService();

export default {
    name: 'ConfirmationStep',
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
        },
    },
    data() {
        return {
            feedback: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        ...mapGetters({
            user: 'account/getUser',
            getPauseIsCancel: 'subscription/getPauseIsCancel',
            isUSA: 'localisation/isUSA',
        }),
        getTitleBasedOnPauseReason() {
            switch (this.pauseSurveyAnswer.id) {
            case 4:
                return this.$t('PAUSE_DELIVERIES_ANYTHING_BETTER_HOUSE', { username: this.user.first_name });
            case 5:
                return this.$t('PAUSE_DELIVERIES_ANYTHING_BETTER_GOING_AWAY');
            case 7:
                return this.$t('PAUSE_DELIVERIES_ANYTHING_BETTER_RENOVATING_HOUSE');
            default:
                return this.$t('PAUSE_DELIVERIES_ANYTHING_BETTER');
            }
        },
        handlingForCountry() {
            return this.isUSA ? this.getTitleBasedOnPauseReason : this.$t('PAUSE_DELIVERIES_ANYTHING_BETTER');
        },
    },
    methods: {
        pauseSubscription() {
            if (this.isUSA && !this.feedback) {
                this.errorHandler.setResponse(this.$t('PAUSE_DELIVERIES_CONFIRM_VALIDATION_ERROR'));
                return;
            }
            subscriptionService.pauseSubscription({ subscriptionId: this.subscriptionId, reason: this.pauseSurveyAnswer.label, feedback: this.feedback, resumeDate: null })
                .then(() => this.$emit('deliveries-paused'))
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
};
</script>

<style lang="scss" scoped>

.feedback--question {
    margin: 24px 0 16px;
    text-align: left;
}

.feedback--textarea {
    font-size: 18px;
    line-height: 22px;
    padding: 8px 12px;
    height: 100px;
}

.confirm--button {
    margin: 28px 0 0;
}

.pause-error--message {
    margin: 0;
    padding: 0 16px;
    font-size: 16px;
    text-align: center;
}

</style>
